import { useQueries } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../api";
import { IOC, ThreatActor } from "../@types/actor";

const useGetCombinedActorData = (actors: string[]) => {
  const actorQueries = useQueries({
    queries: actors.map(actorName => ({
      queryKey: ["getActorSummary", actorName],
      queryFn: () => api.getActorSummary(actorName || ""),
      select: ({ data: responseData }: AxiosResponse<ThreatActor>) =>
        responseData,
      enabled: !!actorName
    })),
    combine: results => {
      const allIOCs: IOC[] = [];
      const allSources: string[] = [];
      const seenIOCs = new Set<string>();
      const seenSources = new Set<string>();
      results.forEach(result => {
        (result.data?.iocs || []).forEach((ioc: IOC) => {
          const key = `${ioc.type}:${ioc.value}`;
          if (!seenIOCs.has(key)) {
            seenIOCs.add(key);
            allIOCs.push(ioc);
          }
        });
        (result.data?.sources || []).forEach((source: string) => {
          if (!seenSources.has(source)) {
            seenSources.add(source);
            allSources.push(source);
          }
        });
      });

      const isLoading = results.some(q => q.isLoading);

      return {
        combinedIOCs: allIOCs,
        combinedSources: allSources,
        isLoading
      };
    }
  });

  return {
    combinedIOCs: actorQueries.combinedIOCs,
    combinedSources: actorQueries.combinedSources,
    isLoading: actorQueries.isLoading
  };
};

export default useGetCombinedActorData;
